<template src="./template.html" ></template>

<script>
import myAxios from '../../functions/myAxios'
// import vueAxios from '../../functions/vueAxios'
import MyAlert from '../../components/alert/MyAlert.vue'
import MyListButtons from '../add/Buttons.vue'
export default {
  name: 'fiscal_year',
  props: ['formTitle'],
  data() {
    return {
      valid: false,
      alert: false,
      model: {},
      requiredRules: [
        v => !!v || 'فیلد اجباری',
      ],
    }
  },
  async beforeCreate() {
    this.formState = this.$router.currentRoute.path.split("/")[2]
    this.route = this.$store.getters.pageInfo.route
    // if (this.formState === 'edit') {
    //   let _mid = this.$router.currentRoute.path.split("/")[3]
    //   let data = {
    //     url: `/api/${this.route}`,
    //     params: {
    //       mid: _mid
    //     },
    //   }
    //   await this.$store.dispatch('getInfo', data)
    //   this.model = this.$store.getters.editData
    // }
  },
  methods: {
    async index() {
      let res = await myAxios({
        method: 'GET',
        url: `/api/INDEX`
      });
      console.clear();
      console.log(res.data);
    },
    async initBoxes() {
      let res = await myAxios({
        method: 'GET',
        url: `/api/initBoxes`
      });
      alert(res.data.insert, 'boxes');
    },
    async initProducts() {
      let res = await myAxios({
        method: 'GET',
        url: `/api/initProducts`
      });
      alert(res.data.insert, 'products');
    },
    async initBankAccounts() {
      let res = await myAxios({
        method: 'GET',
        url: `/api/initBank_accounts`
      });
      alert(res.data.insert, 'bankaccounts');
    },
    async initPersons() {
      let res = await myAxios({
        method: 'GET',
        url: `/api/initPersons`
      });
      alert(res.data.insert, 'persons');
    },
    async initCheques() {
      let res = await myAxios({
        method: 'GET',
        url: `/api/initCheques`
      });
      alert(res.data.insert, 'cheques');
    },
  },
  // mounted() {
  //   this.$refs.title.focus()
  // },
  components: {
    MyAlert,
    MyListButtons
  },
}
</script>

<style lang="scss" scoped>
</style>
